<template>
  <div id="app">
    <spinner v-show="!isLoad" over></spinner>

    <component
      @root-load="rootLoadHandler"
      :is="currentStepComponent"
    ></component>
    <modals-container />
    <debug-panel v-if="isDevelopMode"></debug-panel>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { spinner } from '@/components/core';
import preparation from '@/steps/01_preparations/main.vue';
import errorModal from '@/components/errorModal/errorModal.component.vue';

const debugPanel = () => import('@/components/debug/debugPanel.component.vue');

export default {
  name: 'app',
  components: {
    preparation,
    spinner,
    debugPanel,
  },
  data() {
    return {
      isLoad: false,
      isEnableRootLoadHandler: false,
      steps: [
        {
          name: 'first',
          component: preparation,
        },
        {
          name: 'second',
          component: () => import('@/steps/02_shipment-details/main.vue'),
        },
      ],
    };
  },
  watch: {
    language() {
      this.$i18n.locale = this.language;
    },
  },
  created() {
    const { DHL_CALC_LOCALE } = window;
    if (DHL_CALC_LOCALE) {
      switch (DHL_CALC_LOCALE) {
        case 'en':
          this.switchLangEn();
          break;
        case 'ru':
        default:
          this.switchLangRu();
      }
    }
  },
  async mounted() {
    this.$i18n.locale = this.language;
    this.initErrorHandler();

    const { commit, dispatch } = this.$store;

    try {
      await this.$api.authorize();

/*       this.$api.getServicePoints({}).then((servicePoints) => {
        dispatch('preparation/setServicePoints', servicePoints);
      }); */
      const settings = await this.$api.getSettings();
      commit('api/setInvoiceProcessingType', settings.invoiceProcessingType || 0);
      await dispatch('common/setSessionSettings', settings);
    } catch (e) {
      dispatch('api/setError', e.message);
    }

    if (this.isEnableRootLoadHandler !== true) {
      this.isLoad = true;
    }

    this.initExternalSettings();
  },
  computed: {
    isDevelopMode() {
      return process.env.NODE_ENV === 'development';
    },
    step() {
      return this.$store.state.common.step;
    },
    currentStepComponent() {
      return this.steps[this.step].component;
    },
    language() {
      return this.$store.getters['api/language'];
    },
    texts() {
      return {
        iataCodeErrorTitle: this.$t('IataCodeErrorTitle'),
        iataCodeErrorText: this.$t('IataCodeErrorText'),
      };
    },
  },
  methods: {
    ...mapActions('preparation', ['setCalcDeliverySet']),
    rootLoadHandler(isLoad) {
      if (isLoad === true) {
        this.isEnableRootLoadHandler = true;
        this.isLoad = false;
      } else {
        this.isEnableRootLoadHandler = false;
        this.isLoad = true;
      }
    },
    switchLangRu() {
      this.$store.dispatch('api/setLangRu');
    },
    switchLangEn() {
      this.$store.dispatch('api/setLangEn');
    },
    initErrorHandler() {
      this.$store.subscribe(({ type, payload }) => {
        switch (type) {
          case 'api/setError':
            this.showModalError(payload);
            break;
          default:
            break;
        }
      });
    },
    showModalError(error) {
      console.error(error);
      this.$modal.show(
        errorModal,
        {
          ...error,
        },
        {},
        {
          'before-close': () => {
            const isProcessShipmentErrorUrl = this.$store.getters[
              'api/isProcessShipmentErrorUrl'
            ];
            this.$store.dispatch('api/removeError', error);
            if (
              (isProcessShipmentErrorUrl &&
                !(error.code === 'TOO_CLOSE' || error.code === 'TOO_FAR')) ||
              (!isProcessShipmentErrorUrl && error.code === 'NO_WAYS')
            ) {
              window.location.reload();
            }
          },
        },
      );
    },
    initExternalSettings() {
      const { calcDeliverySet } = window;
      if (calcDeliverySet) {
        const {
          token,
          disabledStepTwo,
          disabledWalk,
          disabledClick,
          disabledCall,
        } = calcDeliverySet;

        if (typeof token === 'string' && token.length !== 0) {
          this.setCalcDeliverySet({
            setting: 'token',
            status: token,
          });
        }

        if (typeof disabledStepTwo === 'boolean') {
          this.setCalcDeliverySet({
            setting: 'disabledStepTwo',
            status: disabledStepTwo,
          });
        }

        if (typeof disabledWalk === 'boolean') {
          this.setCalcDeliverySet({
            setting: 'disabledWalk',
            status: disabledWalk,
          });
        }

        if (typeof disabledClick === 'boolean') {
          this.setCalcDeliverySet({
            setting: 'disabledClick',
            status: disabledClick,
          });
        }

        if (typeof disabledCall === 'boolean') {
          this.setCalcDeliverySet({
            setting: 'disabledCall',
            status: disabledCall,
          });
        }
      }
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-bottom: 10vh;
  padding-top: 10px;

  @media (max-width: 1024px) {
    padding-top: 25px;
  }
}
</style>
